<div [formGroup]="formGroup">
    <fadv-checkbox-card #checkBoxCard formControlName="{{product.id}}" [disabled]="product.isDL && hideDlProduct">
        <fadv-checkbox-card-heading>
            <div *ngIf="product.id != 296">
                {{ product.description }}
            </div>
            <div *ngIf="product.id == 296">
                Credit Report
            </div>
        </fadv-checkbox-card-heading>
        <fadv-checkbox-card-sub-heading>
            <div *ngIf="product.id == 312">
                Highest Education
            </div>
            <div *ngIf="product.id == 456">
                Most Recent Employer
            </div>
        </fadv-checkbox-card-sub-heading>
        <fadv-checkbox-card-badge>${{product.price}}</fadv-checkbox-card-badge>
    </fadv-checkbox-card>
</div>

